import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useCurrentDate } from '#cutils/context/TimeContext';
import { formatTimestamp } from '#utils/time/formatTimestamp';
import { formatTimestampDateTime } from '#utils/time/formatTimestampDateTime';
type Props = {
  className?: string;
  updatedAt?: string | null;
};
export function ArticleUpdatedAtDate(t0) {
  const $ = _c(14);
  const {
    className,
    updatedAt
  } = t0;
  const currentDate = useCurrentDate();
  let t1;
  if ($[0] !== currentDate || $[1] !== updatedAt) {
    t1 = () => updatedAt ? formatTimestamp(updatedAt, currentDate, {
      isAbsolute: true
    }) : null;
    $[0] = currentDate;
    $[1] = updatedAt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [formattedDate, setFormattedDate] = useState(t1);
  let t2;
  let t3;
  if ($[3] !== currentDate || $[4] !== updatedAt) {
    t2 = () => {
      setFormattedDate(updatedAt ? formatTimestamp(updatedAt, currentDate, {
        isAbsolute: true
      }) : null);
    };
    t3 = [currentDate, updatedAt];
    $[3] = currentDate;
    $[4] = updatedAt;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  if (!updatedAt) {
    return null;
  }
  let t4;
  if ($[7] !== updatedAt) {
    t4 = formatTimestampDateTime(updatedAt) ?? undefined;
    $[7] = updatedAt;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = formattedDate ?? undefined;
  let t6;
  if ($[9] !== className || $[10] !== formattedDate || $[11] !== t4 || $[12] !== t5) {
    t6 = <time className={className} dateTime={t4} title={t5} suppressHydrationWarning={true}>{formattedDate}</time>;
    $[9] = className;
    $[10] = formattedDate;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}